import type { TReduxActions } from '../../types/redux';
import { ELoadingStatus } from '../../types/redux/loadingStatus';
import type { INewbuildingsSummaryState } from '../../types/redux/newbuildingsSummary';
import { EGetNewbuildingsSummaryActionTypes } from '../../actions/newbuildingsSummary';

const defaultState: INewbuildingsSummaryState = {
  status: ELoadingStatus.Initial,
  data: null,
  requestId: 0,
};

export function newbuildingsSummaryReducer(
  state: INewbuildingsSummaryState = defaultState,
  action: TReduxActions,
): INewbuildingsSummaryState {
  switch (action.type) {
    case EGetNewbuildingsSummaryActionTypes.Loading:
      return { ...state, requestId: state.requestId + 1, status: ELoadingStatus.Loading };

    case EGetNewbuildingsSummaryActionTypes.Succeed:
      return { ...state, data: action.payload, status: ELoadingStatus.Succeed };

    case EGetNewbuildingsSummaryActionTypes.Failed:
      return { ...state, status: ELoadingStatus.Failed };

    default:
      return state;
  }
}
